import {
    EthTokenStardard,
    FloorGameBlockchain,
    FloorGameCrypto,
    FloorGameCryptoCode,
    FloorGameEthTierFloor,
    FloorGameTierLabel,
    type NftTimeline,
    NftTransaction,
} from '@pkg/types/app/floorGame';
import { timeMeasurement } from '@pkg/utils';

export const ethMaxDecimalLength = 4;
export const ethSmallestIncrement = 0.0001;

export function determineDeathGame(lastSale = 0) {
    if (!lastSale) return false;

    const difference = Date.now() - lastSale;
    return difference > timeMeasurement.msPerDay;
}

// TODO: `currency` currently is not used as we only support Ethereum.
// It should be used once we support multiple blockchains.
// currency = FloorGameCrypto.Ether
export function determineTier(price = 0) {
    if (price >= FloorGameEthTierFloor.Tier5) return FloorGameTierLabel.Tier5;
    if (price >= FloorGameEthTierFloor.Tier4) return FloorGameTierLabel.Tier4;
    if (price >= FloorGameEthTierFloor.Tier3) return FloorGameTierLabel.Tier3;
    if (price >= FloorGameEthTierFloor.Tier2) return FloorGameTierLabel.Tier2;

    return FloorGameTierLabel.Tier1;
}

export function getTierMinValue(tier = FloorGameTierLabel.Tier1) {
    if (tier === FloorGameTierLabel.Tier1) return FloorGameEthTierFloor.Tier1;
    if (tier === FloorGameTierLabel.Tier2) return FloorGameEthTierFloor.Tier2;
    if (tier === FloorGameTierLabel.Tier3) return FloorGameEthTierFloor.Tier3;
    if (tier === FloorGameTierLabel.Tier4) return FloorGameEthTierFloor.Tier4;

    return FloorGameEthTierFloor.Tier5;
}

export function nextTierValue(tier = FloorGameTierLabel.Tier1) {
    if (tier === FloorGameTierLabel.Tier1) return FloorGameEthTierFloor.Tier2;
    if (tier === FloorGameTierLabel.Tier2) return FloorGameEthTierFloor.Tier3;
    if (tier === FloorGameTierLabel.Tier3) return FloorGameEthTierFloor.Tier4;
    if (tier === FloorGameTierLabel.Tier4) return FloorGameEthTierFloor.Tier5;

    // Not sure what to show when we are already at the max tier.
    return 9999;
}

export function nextTierValueFromPrice(price = 0) {
    const currentTier = determineTier(price);
    return nextTierValue(currentTier);
}

export function formatUsdPrice(price = 0) {
    return price > 0 ? price.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : undefined;
}

export function getCryptoCurrency(blockchain: FloorGameBlockchain) {
    if (blockchain === FloorGameBlockchain.Ethereum) {
        return FloorGameCrypto.Ethereum;
    }

    return undefined;
}

export function getCryptoCode(currency?: FloorGameCrypto) {
    // TODO: We should consider taking `blockchain` as the argument.
    if (currency === FloorGameCrypto.Ethereum) {
        return FloorGameCryptoCode.Ethereum;
    }

    return undefined;
}

export function getLastSaleFromEvents(events: NftTimeline = []) {
    const lastSaleEvent = events.find((event) => event.type === NftTransaction.Sale);
    return lastSaleEvent?.timestamp;
}

export function getTokenStandard(standard: string) {
    const normalizedStandard = standard.replace(/[- .]/g, '').toUpperCase();
    switch (normalizedStandard) {
        case 'ERC721':
            return EthTokenStardard.Erc721;
        case 'ERC1155':
            return EthTokenStardard.Erc1155;
        default:
            return undefined;
    }
}
